import { useCallback, useState } from 'react';
import { useParams } from 'react-router-dom';

import { URL_ROUTES } from '@/constants';
import { mergeFastCheckoutCart } from '@/modules/cart/services/api/mutation/mergeFastCheckoutCart.mutations';

interface UseMergeFastCheckoutCartReturn {
  isLoading: boolean;
  error: string | null;
  mergeAndRedirectToCart: () => Promise<void>;
  mergeAndRedirectToHome: () => Promise<void>;
}

export const useMergeFastCheckoutCart = (): UseMergeFastCheckoutCartReturn => {
  const { cartId } = useParams<{ cartId: string }>();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const originURL = typeof window !== 'undefined' ? window.location.origin : '';

  const mergeCart = useCallback(async (): Promise<boolean> => {
    if (!cartId) {
      console.error('No cartId available for merge');
      setError('No cart RUT available');
      return false;
    }

    setIsLoading(true);
    setError(null);

    try {
      await mergeFastCheckoutCart(cartId);
      return true;
    } catch (error) {
      setError('Error al combinar el carrito');
      return false;
    } finally {
      setIsLoading(false);
    }
  }, [cartId]);

  const mergeAndRedirectToCart = useCallback(async () => {
    const success = await mergeCart();
    if (success) {
      window.location.href = `${originURL}${URL_ROUTES.CART}`;
    }
  }, [mergeCart, originURL]);

  const mergeAndRedirectToHome = useCallback(async () => {
    const success = await mergeCart();
    if (success) {
      window.location.href = `${originURL}${URL_ROUTES.BASE_HOME}`;
    }
  }, [mergeCart, originURL]);

  return {
    isLoading,
    error,
    mergeAndRedirectToCart,
    mergeAndRedirectToHome
  };
};
